import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";

type Props = {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
};

const CategoryEditingConfirmModal: React.FC<Props> = ({ open, onOk, onCancel }) => {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogContent>
        <Typography>
          Changing the selection may cause some of the entered information to be lost - continue?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={onOk}>Continue</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryEditingConfirmModal;
